<template>
    <div>
        <el-card>
            <!-- 搜索区域 -->
            <el-row type="flex" justify="space-between" align="center" style="margin-bottom: 20px">
              <el-input placeholder="请输入系统名称" v-model="searchKeyword" style="width: 300px">
                <template slot="suffix">
                  <el-button type="primary" icon="el-icon-search" @click="handleSearch">
                    搜索
                  </el-button>
                </template>
              </el-input>
              <el-button type="primary" icon="el-icon-plus" @click="handleAddDevice" size="mini">
                添加系统
              </el-button>
            </el-row>

            <!-- 系统表格 -->
            <el-table :data="devices" border class="device-table" stripe highlight-current-row
                :row-class-name="tableRowClassName">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="系统id"></el-table-column>
                <!-- <el-table-column prop="code" label="系统编码" width="230"></el-table-column> -->
                <el-table-column prop="stytemType" label="系统名称"></el-table-column>
                <el-table-column prop="orderNum" label="排序"></el-table-column>
                <el-table-column label="操作" width="360">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEditDevice(scope.row)"
                            class="operation-btn edit-btn">
                            编辑
                        </el-button>
                         <el-button size="mini" type="text" @click="handleViewDetails(scope.row)"
                            class="operation-btn view-btn">
                            传感器分类
                        </el-button>
                        <el-button size="mini" type="text" @click="handleDeleteDevice(scope.row.id)" style="color: red">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
            </div>
        </el-card>

        <!-- 新增系统信息弹窗 -->
        <el-dialog title="新增系统信息" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false"
            :destroy-on-close="true" custom-class="custom-dialog">
            <el-form ref="deviceFormSys" :model="deviceFormSys" :rules="rulestytem" label-width="120px"
                class="device-form">
                <!-- 系统名称 -->
                <el-form-item label="系统名称" prop="stytemType">
                    <el-input v-model="deviceFormSys.stytemType" placeholder="请输入系统名称" maxlength="50" show-word-limit
                        class="form-input"></el-input>
                </el-form-item>
                <el-form-item label="系统排序" prop="orderNum">
                    <el-input v-model="deviceFormSys.orderNum" placeholder="系统排序" maxlength="50" show-word-limit
                        class="form-input"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="dialog-btn cancel-btn">取消</el-button>
                <el-button type="primary" @click="handleSave" class="dialog-btn confirm-btn">保存</el-button>
            </div>
        </el-dialog>



        <!-- 修改系统信息弹窗 -->
        <el-dialog title="修改系统信息" :visible.sync="dialogVisibleEdit" width="500px" :close-on-click-modal="false"
            :destroy-on-close="true" custom-class="custom-dialog">
            <el-form ref="deviceFormSysEdit" :model="deviceFormSysEdit" :rules="rulestytem" label-width="120px"
                class="device-form">
                <!-- 系统名称 -->
                <el-form-item label="系统名称" prop="stytemType">
                    <el-input v-model="deviceFormSysEdit.stytemType" placeholder="请输入系统名称" maxlength="50"
                        show-word-limit class="form-input"></el-input>
                </el-form-item>
                <el-form-item label="系统排序" prop="orderNum">
                    <el-input v-model="deviceFormSysEdit.orderNum" placeholder="系统排序" maxlength="50" show-word-limit
                        class="form-input"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleEdit = false" class="dialog-btn cancel-btn">取消</el-button>
                <el-button type="primary" @click="handleSaveEdit" class="dialog-btn confirm-btn">保存</el-button>
            </div>
        </el-dialog>

        <SensorTypeDrawer ref="sensorTypeDrawer" />


    </div>
</template>

<script>
import { systemList, addSystemType, delsystemtype } from '@/api/system'
import { sensorTypeList, categoryInfo } from '@/api/index'
import SensorTypeDrawer from "@/components/SensorTypeDrawer.vue";
export default {
    name: 'DeviceList',
  components: {SensorTypeDrawer},
    data() {
        return {
            selectedIds: [], // 绑定“选中的传感器id”的数组
            counts: {}, // 存储“每个传感器对应的数量”的对象
            radio: '1',
            searchKeyword: '',
            deviceStatus: '',
            deviceType: '',
            currentPage: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            dialogVisibleEdit: false,
            searchKeywordCode: "",
            deviceequipmentTypes: [],
            // 系统表单数据
            deviceForm: {
                name: '',
                code: '',
                type: ''
            },
            deviceFormSysEdit: {
                stytemType: '',
                orderNum: ''
            },
            deviceFormSys: {
                stytemType: "",
                orderNum: ""
            },
            devices: [],
            // 系统类型选项
            deviceTypes: [],
            // 表单验证规则
            rulestytem: {
                templateName: [
                    { required: true, message: '请输入系统类型', trigger: 'blur' },
                    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                enable: [
                    { required: true, message: '请输入系统编码', trigger: 'blur' },
                    { pattern: /^[A-Za-z0-9_-]+$/, message: '编码只能包含字母、数字、下划线和横线', trigger: 'blur' }
                ]
            },
        }
    },
    watch: {
        // 监听选中id的变化，初始化/清理数量
        selectedIds(newVal, oldVal) {
            // 新增选中项：初始化数量为1（确保响应式，用$set）
            newVal.forEach(id => {
                if (!this.counts[id]) {
                    this.$set(this.counts, id, 1);
                }
            });
            // 取消选中项：删除对应数量（可选，若需保留可注释）
            oldVal.forEach(id => {
                if (!newVal.includes(id)) {
                    this.$delete(this.counts, id);
                }
            });
        }
    },
    computed: {
        // 过滤系统列表 - 优化搜索逻辑
        filteredDevices() {
            // 如果没有搜索关键词，直接返回所有系统
            if (!this.searchKeyword) {
                return [...this.devices];
            }
            const keyword = this.searchKeyword.toLowerCase();
            return this.devices.filter(device => {
                // 确保系统名称和编码存在，避免undefined错误
                const nameMatch = device.name
                    ? device.name.toLowerCase().includes(keyword)
                    : false;
                const codeMatch = device.code
                    ? device.id.toLowerCase().includes(keyword)
                    : false;
                return nameMatch || codeMatch;
            })
        },
        // 分页处理
        pagedDevices() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            return this.filteredDevices.slice(startIndex, endIndex);
        }
    },
    mounted() {
        this.systemInfo();
        // this.categoryList(); // 提前加载系统类型
    },
    methods: {
        // 为表格行添加交替样式
        tableRowClassName({ row, rowIndex }) {
            return rowIndex % 2 === 0 ? 'table-row-even' : 'table-row-odd';
        },


        generateSubmitData() {
            // 遍历选中的ID，映射成后端需要的格式
            this.equipmentTemplateSensorList = this.selectedIds.map((sensorTypeId, index) => {
                return {
                    sensorTypeId: Number(sensorTypeId), // 传感器ID
                    sensorNum: Number(this.counts[sensorTypeId]), // 对应的数量
                    sort: index + 1
                };
            });
        },



        //删除系统
        handleDeleteDevice(id) {
            this.$confirm('确定要删除该系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                const res = await delsystemtype(id)
                if (res.code == "0000") {
                    this.$message.success('系统删除成功')
                    this.systemInfo()
                }
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },



        //新增系统保存
        async handleSave() {
            let list = {
                stytemType: this.deviceFormSys.stytemType,
                orderNum: this.deviceFormSys.orderNum
            }
            const res = await addSystemType(list)
            if (res.code == "0000") {
                this.$message.success('添加系统成功')
                this.systemInfo()
                this.dialogVisible = false;
            }
        },


        //保存编辑的信息
        async handleSaveEdit() {
            let list = {
                id: this.deviceFormSysEdit.id,
                stytemType: this.deviceFormSysEdit.stytemType,
                orderNum: this.deviceFormSysEdit.orderNum
            }
            const res = await addSystemType(list)
            if (res.code == "0000") {
                this.$message.success('修改系统成功')
                this.systemInfo()
                this.dialogVisibleEdit = false;
            }
        },




        handleEditDialogClose() {
            this.selectedIds = [];  // 清空传感器选中状态
            this.counts = {};       // 清空传感器数量
            this.radio = "1";       // 重置启用状态为默认值
            // 重置表单（避免下次打开残留旧数据）
            if (this.$refs.deviceFormEdit) {
                this.$refs.deviceFormEdit.resetFields();
            }
        },


        //点击修改系统信息弹框
        async handleEditDevice(item) {
            this.deviceFormSysEdit.stytemType = item.stytemType
            this.deviceFormSysEdit.orderNum = item.orderNum
            this.deviceFormSysEdit.id = item.id
            this.dialogVisibleEdit = true;
        },




        //系统列表接口
        async systemInfo() {
            try {
                let list = {
                    filter : [],
                    current: this.currentPage,
                    size: this.pageSize,
                }
                if (this.searchKeyword && this.searchKeyword.trim().length > 0){
                  list.filter.push({
                    "name": "stytemType",
                    "value": this.searchKeyword,
                    "type": "LIKE"
                  })
                }
                const res = await systemList(list)
                this.devices = res.result.records || []; // 确保有默认空数组
                this.total = res.result.total;
            } catch (error) {
                console.error(error)
                this.devices = []; // 出错时重置为空数组
            }
        },


        //传感器类型接口
        async sensorType() {
            try {
                const res = await sensorTypeList({});
                this.deviceTypes = res.result.records;
                // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
                this.deviceTypes = this.deviceTypes.map(item => ({
                    ...item,
                    id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
                }));
                this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
            } catch (error) {
                console.error('获取传感器类型失败：', error);
                this.$message.error('加载传感器类型失败，请重试');
            }
        },

        //设备类型接口
        async categoryList() {
            try {
              const param = {
                current : 1,
                size : 1000
              }
                const res = await categoryInfo(param);
                this.deviceequipmentTypes = res.result.records;
                // 如果类型不一致（比如一个是数字，一个是字符串），统一类型
                this.deviceequipmentTypes = this.deviceequipmentTypes.map(item => ({
                    ...item,
                    id: String(item.id) // 统一转为字符串（或Number，看device.categooryId类型）
                }));
                // this.deviceFormEdit.type = String(this.deviceFormEdit.type); // 同步类型
            } catch (error) {
                console.error('获取系统类型失败：', error);
                this.$message.error('加载系统类型失败，请重试');
            }
        },

        // 搜索处理 - 重置页码并重新加载数据
        handleSearch() {
            this.currentPage = 1; // 搜索时重置到第一页
            this.systemInfo()
        },

        handleSizeChange(val) {
            this.pageSize = val;
            // this.currentPage = 1; // 当页面大小改变时，重置到第一页
            this.systemInfo()
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.systemInfo()
        },

        getTypeName(type) {
            const typeMap = {
                temperature: '温度传感器',
                humidity: '湿度传感器',
                switch: '智能开关',
                smoke: '烟雾报警器'
            }
            return typeMap[type] || '未知类型'
        },

        getTypeTagType(type) {
            const typeMap = {
                temperature: 'primary',
                humidity: 'success',
                switch: 'warning',
                smoke: 'info'
            }
            return typeMap[type] || 'default'
        },

        handleAddDevice() {
            this.deviceFormSys = { stytemType: '', orderNum: '' }; // 重置表单
            this.dialogVisible = true;
        },

        handleViewDetails(item) {
            this.$refs.sensorTypeDrawer.handleOpen(item.id);
        },
    }
}
</script>

<style scoped>

</style>
